// extracted by mini-css-extract-plugin
module.exports = {"banner":"_373DTq35oiG6pFRHKClJxQ","modeInfo":"_31cwVuI4Se1X90HrDdxpFo","switchButton":"_11gOgdRQ5rFM-Ru_TnPt15"};